/**
 * Socket listener registry. Maps events to wrapped handlers with observability.
 */
import { SOCKET_EVENTS } from "./socketEvents";
import * as connection from "./handlers/connectionHandlers";
import * as financial from "./handlers/financialHandlers";
import * as trading from "./handlers/tradingHandlers";

const MAX_COUNTER = 100000;

const noisyEvents = [SOCKET_EVENTS.PRICE_TICK];

function wrapHandler(handler, ctx, event) {
  return (data) => {
    try {
      if (typeof window !== "undefined") {
        window.__socketStats = window.__socketStats || {};
        window.__socketStatsSlow = window.__socketStatsSlow || {};
        window.__socketLastEvent = window.__socketLastEvent || {};

        const latency = data?.ts ? Date.now() - data.ts : null;
        const currentCount = window.__socketStats[event] || 0;
        window.__socketStats[event] = Math.min(currentCount + 1, MAX_COUNTER);
        window.__socketLastEvent[event] = Date.now();
        window.__socketLastActivity = Date.now();

        if (latency && latency > 200) {
          window.__socketStatsSlow[event] =
            (window.__socketStatsSlow[event] || 0) + 1;
        }

        if (
          process.env.NODE_ENV !== "production" &&
          !noisyEvents.includes(event)
        ) {
          const keys =
            data && typeof data === "object" ? Object.keys(data) : null;
          console.log("[SOCKET EVENT]", event, { latency, keys });
          if (latency && latency > 200) {
            console.warn("[SOCKET SLOW EVENT]", event, latency);
          }
        }
      }
      handler(data, ctx);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.error("[SOCKET ERROR]", event, err);
      }
    }
  };
}

export function createListeners(ctx) {
  return {
    [SOCKET_EVENTS.CONNECT]: wrapHandler(
      connection.handleConnect,
      ctx,
      SOCKET_EVENTS.CONNECT
    ),
    [SOCKET_EVENTS.DISCONNECT]: wrapHandler(
      connection.handleDisconnect,
      ctx,
      SOCKET_EVENTS.DISCONNECT
    ),
    [SOCKET_EVENTS.CONNECT_ERROR]: wrapHandler(
      connection.handleConnectError,
      ctx,
      SOCKET_EVENTS.CONNECT_ERROR
    ),
    [SOCKET_EVENTS.BALANCE_CHANGED]: wrapHandler(
      financial.handleBalanceChanged,
      ctx,
      SOCKET_EVENTS.BALANCE_CHANGED
    ),
    [SOCKET_EVENTS.FINANCIAL_UPDATE]: wrapHandler(
      financial.handleFinancialUpdate,
      ctx,
      SOCKET_EVENTS.FINANCIAL_UPDATE
    ),
    [SOCKET_EVENTS.ORDER_UPDATED]: wrapHandler(
      trading.handleOrderUpdated,
      ctx,
      SOCKET_EVENTS.ORDER_UPDATED
    ),
    [SOCKET_EVENTS.TRADE_EXECUTED]: wrapHandler(
      trading.handleTradeExecuted,
      ctx,
      SOCKET_EVENTS.TRADE_EXECUTED
    ),
    [SOCKET_EVENTS.PRICE_TICK]: wrapHandler(
      trading.handlePriceTick,
      ctx,
      SOCKET_EVENTS.PRICE_TICK
    ),
  };
}
